<app-menu>
    <div class="header">
        <div class="header-title">
            <h1 class="grid-item" style="margin-bottom: 0; text-align:center; background-color: rgb(145, 2, 2);color: #fdfdfd;">Beacon Devices</h1>
        </div>
    </div><br>
    <div style="align-items: center; justify-content: center;">
        <button mat-raised-button style="background-color: rgb(145, 2, 2); color: #fdfdfd;" (click)="scanNewBeacons()">
            &nbsp;<i class="fa-solid fa-link"></i>&nbsp;&nbsp;Scan for New Beacons
        </button>
    </div><br>
    <ag-grid-angular
    style="width: 100%; height: 76%"
    [rowModelType]="rowModelType"
    [cacheBlockSize]="cacheBlockSize"
    [cacheOverflowSize]="cacheOverflowSize"
    [maxConcurrentDatasourceRequests]="maxConcurrentDatasourceRequests"
    [class]="themeClass"
    [rowData]="rowData"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
    [defaultColDef]="defaultColDef"
    [columnDefs]="columnDefs"
    >
    </ag-grid-angular>

</app-menu>
